// extracted by mini-css-extract-plugin
module.exports = {"textArea":"TextAreaField_textArea__3GNXC","textAreaReadOnly":"TextAreaField_textAreaReadOnly__3H0Lc"};